import React from 'react'
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import OfferPreviewCard from 'modules/Business/modules/Offers/components/OfferCard/components/OfferPreviewCard'
import { useAdminData, errorMessage } from './shared'
import { readable } from './presentation'

export default function CurrentOfferPreview({ offerId, businessName, onClose }) {
  const { data, error } = useAdminData(`/admin/offers/${offerId}/preview`)

  if (data) return <OfferPreviewCard
    details={{ ...data, businessName, type: readable(data.fulfillment) }}
    businessId={data.businessId}
    useBusinessDefault={false}
    businessLogoUrl={data.businessImageUrl ?? null}
    onClose={onClose}
  />

  return <Dialog open onClose={onClose} fullWidth maxWidth="md">
    <DialogTitle>View offer</DialogTitle>
    <DialogContent>{error ? <Alert severity="error">{errorMessage(error)}</Alert> : <Typography>Loading offer preview…</Typography>}</DialogContent>
    <DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
  </Dialog>
}
